import React from "react";
import LegalPage from "@/components/common/LegalPage";
import { company, contact } from "@/config/site";

export default function PrivacyPolicy() {
  return (
    <LegalPage
      seo={{ title: "Privacy Policy | Premier Global Sourcing", description: "How Premier Global Sourcing collects, uses and protects the information you share.", path: "/privacy-policy" }}
      eyebrow="Legal"
      title="Privacy Policy"
      updated="[ADD DATE]"
      breadcrumbs={[{ label: "Privacy Policy" }]}
      sections={[
        { heading: "Introduction", body: `${company.legalName} ("we", "us") respects your privacy. This policy explains what information we collect when you use our website or submit an enquiry, and how we use it.` },
        { heading: "Information we collect", body: ["Contact details you provide, such as name, company, email and phone number.", "Enquiry details, including product requirements, quantities, destinations and any files you upload.", "Basic technical information such as browser type and pages visited, where analytics are enabled."] },
        { heading: "How we use your information", body: "We use the information you provide to review and respond to your enquiry, coordinate sourcing and logistics options, and communicate about your request. We do not sell your personal information." },
        { heading: "Sharing", body: "Where necessary to coordinate your requirement, relevant details may be shared with qualified partners such as suppliers or logistics providers. We share only what is needed for the specific purpose." },
        { heading: "Data retention", body: "We keep enquiry information for as long as needed to respond to and manage your request, and to meet any legal or record-keeping obligations." },
        { heading: "Your choices", body: `You may request access to, correction of, or deletion of the information you have shared by contacting us at ${contact.email}.` },
        { heading: "Contact", body: `For any privacy questions, contact ${contact.email}.` },
      ]}
    />
  );
}
